import React from 'react';
import { Stack } from '@mui/material';
import Header from '../components/Header';
import RewardContainer from '../components/RewardContainer';
const RewardPage = () => {

    return (
        <Stack alignItems="center" sx={{flex: 1, height: '100%'}}>
            <Header/>
            <RewardContainer/>
        </Stack>
    );
};

export default RewardPage;
